const admin = {
  title: "לוג פיתוח",
  subtitle: "סקירת מערכת ורישום קומפוננטות",
  breadcrumbDashboard: "דשבורד",
  breadcrumbAdmin: "ניהול מערכת",
  lastUpdated: "עדכון אחרון",
  branch: "ענף",
  activePages: "דפים פעילים",
  placeholderPages: "ממתינים",
  components: "קומפוננטות",
  fieldsMapped: "שדות ממופים",
  widgetsLabel: "ווידג'טים",
  contextsLabel: "קונטקסטים",
  phaseProgress: "התקדמות לפי שלב",
  phase1: "שלב 1 — בסיס",
  phase2: "שלב 2 — עורך",
  phase3: "שלב 3 — מפת סיפורים",
  phase4: "שלב 4 — מרכז AI",
  phase5: "שלב 5 — תוספות",
  tabRoutes: "דפים ונתיבים",
  tabWidgets: "ווידג'טים",
  tabContexts: "קונטקסטים",
  filterPhase: "שלב",
  filterStatus: "סטטוס",
  filterAll: "הכל",
  dashboardRoutes: "נתיבי דשבורד",
  standalonePages: "דפים עצמאיים",
  visible: "נראה",
  hidden: "מוסתר",
  sidebar: "סיידבר",
  statusActive: "פעיל",
  statusPlaceholder: "ריק",
  statusComingSoon: "בקרוב",
  statusDeprecated: "הוסר",
  architectureStack: "מבנה טכנולוגי",
  tabChangelog: "יומן שינויים",
  tabStoryMap: "מפת סיפורים",
  changelogTitle: "יומן שינויים ומעקב",
  committedChanges: "שינויים שבוצעו (Commits)",
  uncommittedChanges: "שינויים לא שמורים",
  untrackedFiles: "קבצים חדשים",
  modifiedFiles: "קבצים ששונו",
  dataCcIdSystem: "מערכת data-cc-id",
  dataCcIdExplanation: "מזהים ייחודיים על אלמנטים בממשק שמאפשרים עקיפות סגנון דינמיות דרך StyleOverrideContext. כל אלמנט עם data-cc-id ניתן להתאמה אישית בהגדרות.",
  dataCcIdTextExplanation: "אלמנטים עם data-cc-text=\"true\" ניתנים גם לעריכת טקסט ישירה.",
  totalIds: "סה\"כ מזהים",
  textEditableIds: "ניתנים לעריכת טקסט",
  filesWithIds: "קבצים עם מזהים",
  featureStatus: "סטטוס פיצ׳ר",
  working: "עובד",
  notVerified: "לא אומת",
  broken: "שבור",
  committed: "נשמר",
  uncommitted: "לא נשמר",
  feature: "פיצ׳ר",
  status: "סטטוס",
  files: "קבצים",
  notes: "הערות",
  commitHash: "Commit",
  directLink: "קישור ישיר",
  searchChangelog: "חיפוש ביומן",
  searchPlaceholder: "חפש פיצ׳ר, קובץ, commit...",
  directMatches: "תוצאות ישירות",
  relatedConnected: "קשרים ותלויות",
  noSearchResults: "לא נמצאו תוצאות",
  architectureDiagram: "מפת ארכיטקטורה",
  diagramLoading: "טוען דיאגרמה...",
  commitButton: "שמור שינויים",
  deployButton: "פרוס לייצור",
  commitPlaceholder: "תיאור השינויים...",
  commitSuccess: "Commit בוצע בהצלחה",
  commitError: "שגיאה בשמירה",
  deploySuccess: "פריסה הצליחה",
  deployError: "שגיאה בפריסה",
  devOnly: "פיתוח בלבד",
  enterCommitMessage: "הזן הודעת commit",
  confirmDeploy: "בטוח? זה ישמור וידחוף ל-main",
  loadingGit: "טוען סטטוס git...",
  gitError: "שגיאה בטעינת git",
  liveStatus: "סטטוס חי",
  pushing: "דוחף...",
  committing: "שומר...",
  nothingToCommit: "אין שינויים לשמור",
  // Workflow statuses
  wfInbox: "נכנס",
  wfWishlist: "רשימת משאלות",
  wfTodo: "לביצוע",
  wfNext: "הבא",
  wfInProgress: "בביצוע",
  wfHold: "המתנה",
  wfStuck: "תקוע",
  wfFreeze: "קפוא",
  wfComplete: "הושלם",
  wfCancelled: "בוטל",
  // Sort
  sortBy: "מיין לפי",
  sortDate: "תאריך",
  sortName: "שם",
  sortPhase: "שלב",
  sortWorkflow: "סטטוס עבודה",
  sortFileCount: "מספר קבצים",
  // Group
  groupBy: "קבץ לפי",
  groupNone: "ללא",
  groupWorkflow: "סטטוס עבודה",
  groupPhase: "שלב",
  groupDate: "תאריך",
  groupFileDir: "תיקייה",
  // Filter
  filterWorkflow: "סטטוס עבודה",
  filterTechStatus: "סטטוס טכני",
  workflowStatus: "סטטוס עבודה",
  noPhase: "ללא שלב",
  // Dev Checklist
  devChecklist: "צ׳קליסט פיתוח",
  devChecklistTitle: "צ׳קליסט פיתוח — השלמת פיצ׳רים",
  checklistDone: "השלמת צ׳קליסט",
  checklistItemsDone: "פריטים הושלמו",
  noChecklist: "ללא צ׳קליסט",
  reviewedBy: "נסקר ע״י",
  clGuideContent: "תוכן מדריך",
  clUsageDoc: "תיעוד שימוש",
  clDiagram: "דיאגרמה",
  clAiSourceOfTruth: "מקור אמת AI",
  clConflictReview: "בדיקת קונפליקטים",
  clGuideContentDesc: "data-cc-id + styleOverrideRegistry + i18n",
  clUsageDocDesc: "purpose + notes מקיפים",
  clDiagramDesc: "connectedTo מאוכלס, מופיע ב-Mermaid",
  clAiSourceOfTruthDesc: "purpose מקיף, הפניה ב-CLAUDE.md",
  clConflictReviewDesc: "נבדקו תלויות, קונטקסטים, localStorage, אירועים",
  auditLinkTitle: "ביקורת קוד — סקירה רב-כובעית",
  auditLinkSubtitle: "4 כובעים · תוכנית · מציאות · איכות · שלמות",
  layerKnowledge: "ידע",
  layerAutomation: "אוטומציה",
  layerMessaging: "הודעות",
  whyBuilt: "למה נבנה",
  connectedToLabel: "מחובר ל:",
  moreFiles: "קבצים",
  results: "תוצאות",
  phaseLabel: "שלב",
  hasRoute: "עם נתיב",
  noRoute: "ללא נתיב",
  connectedToLegend: "מחובר ל",
  routeVisible: "נראה",
  routeHidden: "מוסתר",
  routeSidebar: "סיידבר",
  routeComponents: "קומפוננטות",
  routeContexts: "קונטקסטים:",
  routeTables: "טבלאות:",
  smStories: "סיפורים",
  smDone: "הושלמו",
  smMissing: "חסרים",
  smBroken: "שבורים",
  smCriticalRisks: "סיכונים קריטיים",
  smComplete: "השלמה",
  smUserJourney: "מסע משתמש",
  smReleaseTiers: "שכבות שחרור",
  smRisksTimeline: "סיכונים + ציר זמן",
  smStatusDone: "הושלם",
  smStatusBroken: "שבור",
  smStatusMissing: "חסר",
  smStatusUntested: "לא נבדק",
  smRiskLow: "נמוך",
  smRiskMedium: "בינוני",
  smRiskHigh: "גבוה",
  smRiskCritical: "קריטי",
  smEmotion: "רגש",
  smFriction: "חיכוך",
  smAha: "רגע אהא",
  smThStory: "סיפור",
  smThStatus: "סטטוס",
  smThRisk: "סיכון",
  smThFile: "קובץ",
  smThTask: "משימה",
  smThEffort: "מאמץ",
  smUnhappyPaths: "נתיבים לא שמחים",
  smTasks: "משימות",
  smRiskMatrix: "מטריצת סיכונים",
  smRiskCol: "סיכון",
  smType: "סוג",
  smLevel: "רמה",
  smMitigation: "מיטיגציה",
  smImplSequence: "רצף יישום",
  smMlpSubtitle: "המוצר שאוהבים",
  smMlpKpis: "KPIs: שימוש יומי >80%, יצירת מסמך <2 דקות, סשני AI >10/שבוע/משתמש, שביעות רצון >4/5",
  smVerificationTitle: "אימות לכל שכבה",
  smVerifyWs: "כניסה → דשבורד מרונדר → פרויקטים נראים",
  smVerifyMvp: "כל 12 הדפים עובדים, CRUD בכל הטבלאות, AI streaming, realtime מסתנכרן",
  smVerifyMlp: "מסע משתמש מלא ללא נתוני הדגמה, כל האינטגרציות חיות, סקר שביעות רצון >4/5",
  wfLabelInbox: "נכנס",
  wfLabelWishlist: "משאלות",
  wfLabelTodo: "לביצוע",
  wfLabelNext: "הבא",
  wfLabelInProgress: "בביצוע",
  wfLabelHold: "המתנה",
  wfLabelStuck: "תקוע",
  wfLabelFreeze: "קפוא",
  wfLabelComplete: "הושלם",
  wfLabelCancelled: "בוטל",
} as const;
export default admin;
